import React from 'react'
import { connect } from 'react-redux'

import { doGetCustomTemplateList, doGetPrintTemplateList, doDefultCoordinator, doGetArchivesTempletList } from '../../reducers/actions'
import { addListItem, changeListItem, deleteListItem } from '../../public/utility'
import ContractFlowDiv from './ContractFlowDiv'
import SampleFlowDiv from './SampleFlowDiv'
import OutApplyFlowDiv from './OutApplyFlowDiv'
import CustomTemplateDiv from './CustomTemplateDiv'
import PrintTemplateDiv from './PrintTemplateDiv'
import ContractNumberRuleList from './ContractNumberRuleList'
import SampleNumberRuleList from './SampleNumberRuleList'
import EmailTempletListDiv from './EmailTempletListDiv'
import AutoNumberListDiv from './AutoNumberListDiv'
import PrinterListDiv from './PrinterListDiv'
import ArchivesTemplet from './ArchivesTemplet'
import ShiftList from './ShiftList'
import PersonAttachKindList from './PersonAttachKindList'

import SalaryAccountSettingDiv from './SalaryAccountSettingDiv'
import SalaryAdjustmentSettingDiv from './SalaryAdjustmentSettingDiv'
import SalarySettingDiv from './SalarySettingDiv'
import BonusSettingDiv from './BonusSettingDiv'
import PurchaseOrderPrintDiv from './PurchaseOrderPrintDiv'
import AssetChangePrintDiv from './AssetChangePrintDiv'
import AssetAccPrintDiv from './AssetAccPrintDiv'

const sysTemplate = {
	'合同流程': ContractFlowDiv,
	'样品流程': SampleFlowDiv,
	'外出流程': OutApplyFlowDiv,
	'合同自动编号规则': ContractNumberRuleList,
	'样品自动编号规则': SampleNumberRuleList,
	'自动编号设置': AutoNumberListDiv,
	'邮件模板设置': EmailTempletListDiv,
	'打印机端口': PrinterListDiv,
	'班别管理': ShiftList,
	'人员附加分类': PersonAttachKindList,

	'薪资科目设置': SalaryAccountSettingDiv,
	'调薪设置': SalaryAdjustmentSettingDiv,
	'薪资设置': SalarySettingDiv,
	'奖金设置': BonusSettingDiv,
	'采购单打印凭证': PurchaseOrderPrintDiv,
	'资产异动单打印': AssetChangePrintDiv,
	'资产验收单打印': AssetAccPrintDiv,
}


class SysSettings extends React.Component {
	state = {
		initValues系统模板: {
			...(Object.keys(sysTemplate).reduce((a, v, i) => {
				a['模板'].push(i + 1)
				a[`模板[${i + 1}].id`] = i + 1
				a[`模板[${i + 1}].模板名称`] = v
				return a
			}, { '模板': [] })),
		}
	}

	componentDidMount = () => {
		this.handleInitCustomTemplate()
		this.handleInitPrintTemplate()
		this.handleInitArchivesTemplet()
	}

	handleInitCustomTemplate = () => {
		const { onSave, onClose, dispatch } = this.props
		dispatch(doGetCustomTemplateList({
			onEnd: ({ errorMessage, initValues自定义模板 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else if (initValues自定义模板) {
					this.setState({ initValues自定义模板 })
				}
			}
		}))
	}

	handleInitPrintTemplate = () => {
		const { onSave, onClose, dispatch } = this.props
		dispatch(doGetPrintTemplateList({
			onEnd: ({ errorMessage, initValues公共标签打印模板 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else if (initValues公共标签打印模板) {
					this.setState({ initValues公共标签打印模板 })
				}
			}
		}))
	}

	handleDefultCoordinator = () => {
		const { dispatch } = this.props
		dispatch(doDefultCoordinator({
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				Ext.toast('恢复成功')
			}
		}))
	}
	handleEditSysTemplate = (data) => {
		const Comp = sysTemplate[data['模板名称']]

		Comp && Tyan.pubForm.showDialog(data['模板名称'], props => <Comp {...props} />)

		// if (data['模板名称'] === '合同流程') {
		//   Tyan.pubForm.showDialog('合同流程', props => <ContractFlowDiv {...props} />)
		// }
		// if (data['模板名称'] === '样品流程') {
		//   Tyan.pubForm.showDialog('样品流程', props => <SampleFlowDiv {...props} />)
		// }
		// if (data['模板名称'] === '合同自动编号规则') {
		//   Tyan.pubForm.showDialog('合同自动编号规则', props => <ContractNumberRuleList {...props} />)
		// }
		// if (data['模板名称'] === '样品自动编号规则') {
		//   Tyan.pubForm.showDialog('样品自动编号规则', props => <SampleNumberRuleList {...props} />)
		// }
		// if (data['模板名称'] === '自动编号设置') {
		//   Tyan.pubForm.showDialog('自动编号列表', props => <AutoNumberListDiv {...props} />)
		// }
		// if (data['模板名称'] === '邮件模板设置') {
		//   Tyan.pubForm.showDialog('邮件模板', props => <EmailTempletListDiv {...props} />)
		// }
		// if (data['模板名称'] === '打印机端口') {
		//   Tyan.pubForm.showDialog('打印机端口', props => <PrinterPortDiv {...props} />)
		// }
		// this.setState({})      无效语句
	}


	handleAddCustomTemplate = (data) => {
		Tyan.pubForm.showDialog('自定义模板', props => <CustomTemplateDiv {...props} id={-1} onSave={this.handleInitCustomTemplate} />)
		// window.alert(`自定义模板:${data.id} ${data['模板名称']}`)
		// onSave....
		this.setState({})
	}

	handleEditSysCustomTemplate = (data) => {
		Tyan.pubForm.showDialog('自定义模板', props => <CustomTemplateDiv {...props} id={data.id} onSave={this.handleInitCustomTemplate} />)
		this.setState({})
	}
	handleAddPrintTemplate = (data) => {
		Tyan.pubForm.showDialog('公共标签打印模板', props => <PrintTemplateDiv {...props} id={-1} onSave={this.handleInitPrintTemplate} />)
		this.setState({})
	}

	handleEditSysPrintTemplate = (data) => {
		Tyan.pubForm.showDialog('公共标签打印模板', props => <PrintTemplateDiv {...props} id={data.id} onSave={this.handleInitPrintTemplate} />)
		this.setState({})
	}

	//公文模板
	handleInitArchivesTemplet = () => {
		const { onSave, onClose, dispatch } = this.props
		dispatch(doGetArchivesTempletList({
			onEnd: ({ errorMessage, initValues公文模板 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else if (initValues公文模板) {
					this.setState({ initValues公文模板 })
				}
			}
		}))
	}

	handleAddArchivesTemplet = (data) => {
		Tyan.pubForm.showDialog('公文模板', props => <ArchivesTemplet {...props} id={-1} onSave={this.handleInitArchivesTemplet} />)
		this.setState({})
	}

	handleEditArchivesTemplet = (data) => {
		Tyan.pubForm.showDialog('公文模板', props => <ArchivesTemplet {...props} id={data.id} onSave={this.handleInitArchivesTemplet} />)
		this.setState({})
	}

	fieldset系统模板 = () => {
		return [{
			_grid: '', name: '模板', rowNumbers: true, minRows: 5, /* maxRows: 11,  */minWidth: '300', height: '100%',
			columns: [
				{ _text: '模板名称', flex: 1/* , tools: [{ _tool: '修改', handler: this.handleEditSysTemplate }]  */ },
			],
			buttons: [
				{
					_button: '社保公司扣款金额数据处理', /* icon: 'plus', */  handler: () =>
						Tyan.pubForm.showConfirm('确定要更新？', () => {
							Tyan.doPostEvent({
								event: 'SocialSecurityCompanyAmountProcessing',
								data: {},
								onEnd: ({ errorMessage }) => {
									if (errorMessage) {
										Tyan.pubForm.showError(errorMessage)
										return
									}
									Ext.toast('执行成功')
								}
							})
						})
				},
				{
					_button: '生成发票明细', /* icon: 'plus', */  handler: () =>
						Tyan.pubForm.showConfirm('确定要生成发票明细？', () => {
							Tyan.doPostEvent({
								event: 'CreateInvoiceInfo',
								data: {},
								onEnd: ({ errorMessage }) => {
									if (errorMessage) {
										Tyan.pubForm.showError(errorMessage)
										return
									}
									Ext.toast('执行成功')
								}
							})
						})
				},
				// {
				// 	_button: '更新劳动合同续签申请', /* icon: 'plus', */  handler: () =>
				// 		Tyan.pubForm.showConfirm('确定要更新？', () => {
				// 			Tyan.doPostEvent({
				// 				event: 'BatchUpdateHistoricalData',
				// 				data: {},
				// 				onEnd: ({ errorMessage }) => {
				// 					if (errorMessage) {
				// 						Tyan.pubForm.showError(errorMessage)
				// 						return
				// 					}
				// 					Ext.toast('执行成功')
				// 				}
				// 			})
				// 		})
				// },
				// {
				//   _button: '刷新任务', /* icon: 'plus', */  handler: () =>
				//     Tyan.pubForm.showConfirm('确定要初始？', () => {
				//       Tyan.doPostEvent({
				//         event: 'RefreshAllTasks',
				//         data: {},
				//         onEnd: ({ errorMessage }) => {
				//           if (errorMessage) {
				//             Ext.toast(errorMessage)
				//             return
				//           }
				//           Ext.toast('刷新任务已经成功提交')
				//         }
				//       })
				//     })
				// },
				// {
				//   _button: '导入基本信息', handler: () => Tyan.pubForm.showImport(
				//     'ImportBasic',
				//     '导入基本信息',
				//     (data) => { },
				//     '.xls,.xlsx', {}),
				// },
				// {
				//   _button: '导入内部入职', handler: () => Tyan.pubForm.showImport(
				//     'ImportinSideIn',
				//     '导入内部入职',
				//     (data) => { },
				//     '.xls,.xlsx', {}),
				// },
				// {
				//   _button: '导入内部变更', handler: () => Tyan.pubForm.showImport(
				//     'ImportinSideCh',
				//     '导入内部变更',
				//     (data) => { },
				//     '.xls,.xlsx', {}),
				// },
				// {
				//   _button: '导入通讯资料', handler: () => Tyan.pubForm.showImport(
				//     'ImportCommunication',
				//     '导入通讯资料',
				//     (data) => { },
				//     '.xls,.xlsx', {}),
				// },
				// {
				//   _button: '导入外部经历', handler: () => Tyan.pubForm.showImport(
				//     'ImportExternal',
				//     '导入外部经历',
				//     (data) => { },
				//     '.xls,.xlsx', {}),
				// },
				// {
				//   _button: '导入学历资料', handler: () => Tyan.pubForm.showImport(
				//     'ImportEducation',
				//     '导入学历资料',
				//     (data) => { },
				//     '.xls,.xlsx', {}),
				// },
				// {
				//   _button: '导入假期余额', handler: () => Tyan.pubForm.showImport(
				//     'ImportVacationBalance',
				//     '导入假期余额',
				//     (data) => { },
				//     '.xls,.xlsx', {}),
				// },

				// { _button: '恢复台账协调员', /* icon: 'plus', */  handler: this.handleDefultCoordinator, },
			],
			onDoubleTap: this.handleEditSysTemplate
		}]
	}

	fieldset自定义模板 = () => {
		return [{
			_grid: '', name: '模板', rowNumbers: true, minRows: 5, /* maxRows: 11, */height: '100%',
			columns: [
				{ _text: '模板名称', flex: 1 },
				{ _text: '显示名称', flex: 1 },
			],
			buttons: [
				{ _button: '添加新模板...', /* icon: 'plus', */  handler: this.handleAddCustomTemplate, },
			],
			onDoubleTap: this.handleEditSysCustomTemplate,
		}]
	}

	fieldset公共标签打印模板 = () => {
		return [{
			_grid: '', name: '模板', rowNumbers: true, minRows: 5,/*  maxRows: 11, */height: '100%',
			columns: [
				{ _text: '模板名称', flex: 1 },
				{ _text: '打印机名称', flex: 1 },
			],
			buttons: [
				{ _button: '添加新模板...', /* icon: 'plus', */  handler: this.handleAddPrintTemplate, },
			],
			onDoubleTap: this.handleEditSysPrintTemplate
		}]
	}

	fieldset公文模板 = () => {
		return [{
			_grid: '', name: '模板', rowNumbers: true, minRows: 5,/*  maxRows: 11, */height: '100%',
			columns: [
				{ _text: '模板名称', minWidth: 200 },
				{ _text: '说明', minWidth: 300, flex: 1 },
				{ _text: '修改人', minWidth: 150 },
				{ _date: '修改时间', minWidth: 150, align: 'left' },
			],
			buttons: [
				{ _button: '添加新模板...', /* icon: 'plus', */  handler: this.handleAddArchivesTemplet, },
			],
			onDoubleTap: this.handleEditArchivesTemplet
		}]
	}

	render = () => {
		const { showBody: Body } = this.props

		return <Body data={this} /* maxWidth={1200} */
			fieldsets={[
				{ title: '系统参数', name: '系统模板', _fieldset: this.fieldset系统模板(), docked: 'left', height: '100%', fullblock: true/* minWidth: '300' */ },
				{ title: '公共标签打印模板', _fieldset: this.fieldset公共标签打印模板(), docked: 'top', height: '50%', fullblock: true },
				{
					_fieldsets: [
						{ title: '自定义模板', _fieldset: this.fieldset自定义模板(), fullblock: true },
						{ title: '公文模板', _fieldset: this.fieldset公文模板(), fullblock: true },
					]
				}
			]}
		/>
	}
}

export default connect()(SysSettings)